module.exports = __webpack_public_path__ + "img/yzfu.1c0e2487.png";